import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import {
  Container,
  WysiwygField,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ButtonWrapper, Slider } from '../../../components';
import { ParagraphUSP as Type } from '../../../types/uncinc_profile/paragraphs';
import { CONTENT_TYPE_PROJECT, SCREEN_NORMAL } from '../../../config/constants';
import useCurrentNodeType from '../../../helpers/useCurrentNodeType';

import './style.scss';

interface ParagraphUSPProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphUSP: React.FC<ParagraphUSPProps> = ({
  entity,
}) => {
  const paragraphUSP = entity.toJS();

  const title = paragraphUSP.field_title[0]?.value;
  const body = paragraphUSP.field_body[0]?.processed;
  const paragraphs = paragraphUSP.field_paragraphs;
  const link = paragraphUSP.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const secondaryLink = paragraphUSP.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUrl = secondaryLink?.alias || secondaryLink?.uri;

  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_NORMAL;

  const { currentNodeType } = useCurrentNodeType();
  const colClass = currentNodeType === CONTENT_TYPE_PROJECT ? 'col-12 col-md-8 offset-md-2' : 'col-12';

  return (
    <div className="Paragraph ParagraphUSP">
      <Container>
        <div className="row">
          <div className="ParagraphUSP__heading col-12 col-lg-8 offset-md-2">
            <h2>{title}</h2>
            <WysiwygField html={body} />
          </div>
          {(linkUrl || secondaryLinkUrl) && (
            <div className={`ParagraphUSP__buttons ${colClass}`}>
              {linkUrl && (
                <ButtonWrapper
                  href={linkUrl}
                >
                  {linkTitle}
                </ButtonWrapper>
              )}
              {secondaryLinkUrl && (
                <ButtonWrapper
                  href={secondaryLinkUrl}
                >
                  {secondaryLinkTitle}
                </ButtonWrapper>
              )}
            </div>
          )}

          {isMobile ? (
            <div className="ParagraphUSP__slider col-12">
              <Slider>
                {paragraphs.map((paragraph) => (
                  <div key={paragraph.target_id}>
                    <Paragraph
                      entity={Immutable.fromJS(paragraph.entity)}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          ) : (
            <div className={`ParagraphUSP__subparagraphs ${colClass}`}>
              {paragraphs.map((paragraph) => {
                const id = paragraph.target_id;
                return (
                  <Paragraph
                    key={`paragraph:${id}`}
                    id={id}
                    entity={Immutable.fromJS(paragraph.entity)}
                  />
                );
              })}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default ParagraphUSP;
